import { render } from "./NavbarView.vue?vue&type=template&id=754e2e0c&scoped=true"
import script from "./NavbarView.vue?vue&type=script&lang=js"
export * from "./NavbarView.vue?vue&type=script&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=754e2e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754e2e0c"]])

export default __exports__